module.exports = __webpack_public_path__ + "img/1.d12f4c14.jpg";